import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Utils } from './../shared/utils';

import 'rxjs/add/operator/toPromise';

import { TipoCertificado } from './tipo_certificado';

@Injectable()
export class TipoCertificadoService {

  private tipoCertificadoUrl = '/tipo_certificados';

  getTipos(): Promise<TipoCertificado[]> {
    return this.http.get(this.tipoCertificadoUrl)
                .toPromise()
                .then(response => response.json().dados as TipoCertificado[])
                .catch((error) => this.handleError(error));
  }

  getTipoCertificado(id: number): Promise<TipoCertificado>{
    let url: string  = this.tipoCertificadoUrl + '/' + id;
    return this.http.get(url)
               .toPromise()
               .then(response => response.json().dados as TipoCertificado)
               .catch((error) => this.handleError(error));
  }

  saveTipoCertificado(tipoCertificado: TipoCertificado): Promise<Response>{
    let url: string = this.tipoCertificadoUrl;

    if(tipoCertificado.id !== undefined)
      url = url + '/' + tipoCertificado.id;

    return this.http
               .post(url, this.utils.buildFormData(tipoCertificado))
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  deleteTipoCertificado(tipoCertificado: TipoCertificado): Promise<Response>{
    let url: string = this.tipoCertificadoUrl + '/' + tipoCertificado.id ;
    return this.http
               .delete(url)
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  constructor(
    private http: Http,
    private _flashMessagesService: FlashMessagesService,
      private utils: Utils
  ) { }

  private handleSuccess(resp: any): Promise<any> {
    this.utils.flashMessage(resp.msg, 'success');
    //this._flashMessagesService.show(resp.msg, { cssClass: 'alert-success', timeout: 5000 });
    return resp;
  }

  private handleError(error: any): Promise<any> {
     switch (error.status) {
      case 500:
        this.utils.flashMessage('Ocorreu error no servidor, entre em contato com o administrador.', 'danger');
        //this._flashMessagesService.show("Ocorreu error no servidor, entre em contato com o administrador.", { cssClass: 'card alert-danger', timeout: 5000 });
        break;
      case 403:
        if(!Array.isArray(error.json().msg)){
          this.utils.flashMessage(error.json().msg, 'warning');
        } else {
          for(let msg of error.json().msg){
            this.utils.flashMessage(msg, 'warning');
          }
        }
        //this._flashMessagesService.show(error.json().msg, { cssClass: 'card alert-warning', timeout: 5000 });
        break;
      default:
      this.utils.flashMessage("Ocorreu um error, tente novamente mais tarde.", 'danger');
        //this._flashMessagesService.show("Ocorreu um error, tente novamente mais tarde.", { cssClass: 'card alert-danger', timeout: 5000 });
    }
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ./src/app/tipos_certificados/tipo_certificado.service.ts